module.exports = __webpack_public_path__ + "img/home1-7.2ee1f2e8.jpg";